var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])]),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }